import * as React from 'react';
import {
  IContainerProps,
  IContainerImperativeActions,
} from '../../../Container.types';
import { ContainerLogic } from '../../shared/ContainerLogic';
import styles from './RibbonAreaSkin.scss';

const RibbonAreaSkin: React.ForwardRefRenderFunction<
  IContainerImperativeActions,
  IContainerProps
> = (props, ref) => {
  return (
    <ContainerLogic
      {...props}
      ref={ref}
      className={styles.root}
      renderSlot={({ containerChildren }) => (
        <>
          <div className={styles.flRibbon} />
          <div className={styles.frRibbon} />
          <div className={styles.bg} />
          {containerChildren}
        </>
      )}
    />
  );
};

export default React.forwardRef(RibbonAreaSkin);
